import { enableProdMode, LOCALE_ID, ErrorHandler, APP_INITIALIZER, Injector, importProvidersFrom } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { appInit } from "./app/app.module";
import { environment } from "./environments/environment";
import { CookieService } from "ngx-cookie-service";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { EforsyningHttpInterceptor } from "@e-forsyning/common/http";
import { ENV, LOGGER, LogentriesLoggerService } from "@dffedb/util";
import { EforsyningErrorHandler } from "@e-forsyning/common/error";
import { DffRedirectService } from "@dffedb/router";
import { initUmbracoIndstillinger } from "@e-forsyning/common/umbraco-indstillinger";
import { provideAnimations } from "@angular/platform-browser/animations";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { AppShellModule } from "@e-forsyning/common/app-shell";
import { EForsyningLogindKnapModule, DffedbCookieConsentModule, DffedbCookieConsentOverlayModule, DffedbDriftsstatusKnapModule, DffedbEBoksTilmeldModule, DffedbFancyboxModule, DffedbIframeModule, DffedbInfoPopupModule, DffedbPrisberegnerModule, DffedbTilslutningsanmodningModule, DffedbForsyningPaaAdresseModule, DffedbMapModule } from "@e-forsyning/web-components";
import { AppComponent } from "./app/app.component";

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, HttpClientModule, MatSnackBarModule, AppShellModule, EForsyningLogindKnapModule, DffedbCookieConsentModule, DffedbCookieConsentOverlayModule, DffedbDriftsstatusKnapModule, DffedbEBoksTilmeldModule, DffedbFancyboxModule, DffedbIframeModule, DffedbInfoPopupModule, DffedbPrisberegnerModule, DffedbTilslutningsanmodningModule, DffedbForsyningPaaAdresseModule, DffedbMapModule // Registrerer WebComponent <dffedb-forsyning-paa-adresse>
        ),
        // CookieService skal 'provides' for at undgå NullInjectorError i produktionsbuild.
        CookieService,
        {
            provide: LOCALE_ID,
            useValue: "da"
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EforsyningHttpInterceptor,
            multi: true
        },
        {
            provide: ENV,
            useValue: environment
        },
        {
            provide: LOGGER,
            useClass: LogentriesLoggerService
        },
        {
            provide: ErrorHandler,
            useClass: EforsyningErrorHandler
        },
        {
            provide: DffRedirectService,
            useValue: null // Bruges af menuen til at tjekke om vi kan Angular-route eller skal bruge location.href
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInit,
            deps: [Injector],
            multi: true
        },
        provideAnimations()
    ]
});
